import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RestClient} from '../../../../../Api/DcoApi/Client/RestClient';
import {AbsetzungEntry} from '../../../../../Api/DcoApi/Abrechnung/Absetzung';
import {FileEntry} from '../../../../../Api/DcoApi/Abrechnung/FileEntry';


@Component({
  selector: 'absetzungs-dateien',
  imports: [FormsModule, CommonModule],
  templateUrl: './absetzungs-dateien.html',
  styleUrl: './absetzungs-dateien.css',
})
export class AbsetzungsDateien {

  constructor(private cdr: ChangeDetectorRef) { }
  Client: RestClient = new RestClient();
  @Input() Absetzung: AbsetzungEntry | null | undefined = null;
  @Output() AbsetzungChange = new EventEmitter<AbsetzungEntry | null>();
  selectedFile: File | null = null;

  get Files(): FileEntry[] {
    return this.Absetzung?.files ?? [];
  }

  async UploadFile() {
    const input = document.createElement('input');
    input.type = 'file';

    // Event-Handler, wenn die Datei ausgewählt wurde
    input.onchange = (event: any) => {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile) {
        this.Upload();
        this.cdr.detectChanges();
      }
    };

    // Öffnet den Datei-Dialog des Betriebssystems
    input.click();
  }

  async DeleteFile(key: number) {
    if (this.Absetzung != null) {
      await this.Client.Delete(`/Absetzung/${this.Absetzung.key}/File/${key}`);
      this.Absetzung.files = this.Absetzung.files.filter(file => file.key !== key);
      this.cdr.detectChanges();
    }
  }



  async Upload() {
    if ( this.Absetzung != null) {
      if (this.selectedFile != null) {
        this.Absetzung.files.push(await this.Client.PostFile<FileEntry>(`/Absetzung/${this.Absetzung.key}/File`, this.selectedFile));
      }

    }

    this.selectedFile = null;
    this.cdr.detectChanges();
  }
}
